import Routing from "../Routing/Routing";
import Navbar from "../Navbar/navbar";
import { useContext, useState } from "react";
import { UserContext } from "../../../Redux/UserContext";
import jwtDecode from "jwt-decode";
import "./Layout.css";
import { useEffect } from "react";
import authFunctions from "../../../Services/AuthFunctions";
import Loading from "../../SharedArea/Loading/Loading";
import { useDispatch } from "react-redux";
import { fetchOrders } from "../../../Redux/slicers/ordersSlicer";
import { OrdersDispatch, TasksDispatch } from "../../../Redux/OrdersContext";
import { fetchTasks } from "../../../Redux/slicers/tasksSlicer";

function Layout(): JSX.Element {
	interface TokenPayload {
		user_id: number;
	}

	const [isLoaded, setIsLoaded] = useState<boolean>(false);
	const [isLoadedProfile, setIsLoadedProfile] = useState<boolean>(false);
	const context = useContext(UserContext);
	const orderDispatch: OrdersDispatch = useDispatch();
	const tasksDipsatch: TasksDispatch = useDispatch();

	document.addEventListener('focusin', (event: FocusEvent) => {
		const target = event.target as HTMLInputElement | HTMLTextAreaElement;
		if ((target.tagName === 'INPUT' && target.type !== 'checkbox') || target.tagName === 'TEXTAREA') {
			setTimeout(() => {
				const value = target.value;
				target.setSelectionRange(value.length, value.length);
			}, 0); // Ensure this happens after focus
		}
	});

	// document.addEventListener('mousedown', (event: MouseEvent) => {
	// 	const target = event.target as HTMLInputElement | HTMLTextAreaElement;
	// 	if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
	// 		event.preventDefault(); // Prevents default click behavior
	// 		target.focus(); // Ensures the element is focused
	// 		const value = target.value;
	// 		target.setSelectionRange(value.length, value.length); // Moves cursor to the end
	// 	}
	// });

	useEffect(() => {
		const loadUserData = async () => {
			const token = localStorage.getItem("tokens");
			if (!token) {
				setIsLoaded(true);
				setIsLoadedProfile(true);
				return;
			}

			try {
				const tokens = JSON.parse(token);
				const accessToken = tokens.access;

				// Check if token is expired
				const container = jwtDecode<TokenPayload & { exp: number }>(accessToken);
				const currentTime = Date.now() / 1000;
				const isExpired = container.exp < currentTime;

				if (isExpired) {
					// Token is expired, try to refresh it before loading user data
					console.log("Access token expired, refreshing...");
					const refreshed = await authFunctions.refreshToken();

					if (!refreshed) {
						// Refresh failed, user needs to log in again
						console.log("Token refresh failed, clearing tokens");
						setIsLoaded(true);
						setIsLoadedProfile(true);
						return;
					}

					console.log("Token refreshed successfully");

					// Get the new token and decode it
					const newTokens = JSON.parse(localStorage.getItem("tokens"));
					const newContainer = jwtDecode<TokenPayload>(newTokens.access);

					// Load user data with refreshed token
					await loadUserDataById(newContainer.user_id);
				} else {
					// Token is valid, proceed with loading user data
					await loadUserDataById(container.user_id);
				}
			} catch (error) {
				// Invalid token format
				console.error("Invalid token:", error);
				localStorage.removeItem("tokens");
				setIsLoaded(true);
				setIsLoadedProfile(true);
			}
		};

		const loadUserDataById = async (userId: number) => {
			try {
				const userResponse = await authFunctions.getUserById(userId);
				context.user = userResponse;

				const profile = await authFunctions.getUserProfileById(userResponse.id);
				context.profile = profile;
				setIsLoadedProfile(true);

				orderDispatch(fetchOrders());
				tasksDipsatch(fetchTasks());
			} catch (error) {
				// If fetching user data fails, clear invalid token
				console.error("Failed to load user data:", error);
				localStorage.removeItem("tokens");
			} finally {
				setIsLoaded(true);
			}
		};

		loadUserData();
	}, [context, orderDispatch, tasksDipsatch]);

	if (!isLoaded || !isLoadedProfile) {
		return <Loading />;
	}

	return (
		<div className="Layout" id="Layout">
			<header>
				<Navbar></Navbar>
			</header>
			<main>
				<Routing></Routing>
			</main>
		</div>
	);
}

export default Layout;
